<section
  class="email-modal"
  role="dialog"
  aria-modal="true"
  aria-labelledby="email-modal-title"
  aria-describedby="email-modal-description"
>
  <button
    type="button"
    class="email-modal__close"
    aria-label="Close email modal"
    [disabled]="isSaving()"
    (click)="onClose()"
  >
    <span aria-hidden="true"> × </span>
  </button>

  <lib-icon class="email-modal__icon" iconName="emailIcon" aria-hidden="true" />

  <div class="email-modal__content">
    <h2 id="email-modal-title" class="email-modal__title">
      {{ mode() === "edit" ? "Update email" : "Add email" }}
    </h2>

    @if (mode() === "edit") {
      <div id="email-modal-description" class="email-modal__message">
        <p>
          Updating the email will also change the adopter’s login credentials.
        </p>

        <p>
          After completing the update, they will be automatically logged out. An
          account change email will be sent to the new email address
        </p>
      </div>
    } @else {
      <div id="email-modal-description" class="email-modal__message">
        <p>Adding an email will create login credentials for this adopter.</p>

        <p>
          After adding the email, the adopter will receive instructions at the
          new address explaining how to log in.
        </p>
      </div>
    }

    @if (errorMessage()) {
      <lib-ds-notice
        class="email-modal__error"
        type="error"
        [message]="errorMessage() ?? ''"
        [hideClose]="false"
        (dismiss)="onDismissError()"
      />
    }

    <div class="email-modal__divider" aria-hidden="true"></div>

    <form
      class="email-modal__form"
      [formGroup]="emailForm"
      (ngSubmit)="onSubmit()"
      novalidate
    >
      <lib-ds-form-field
        id="ownerEmail"
        type="email"
        autocomplete="email"
        inputmode="email"
        formControlName="email"
        [label]="mode() === 'edit' ? 'New Email' : 'Email'"
        [required]="true"
        [hasError]="emailControl.invalid && emailControl.touched"
        [errorMessage]="emailValidationMessage"
      />

      <lib-ds-form-field
        id="ownerEmailConfirm"
        type="email"
        autocomplete="off"
        inputmode="email"
        formControlName="confirm"
        label="Confirm Email"
        [required]="true"
        [hasError]="
          (confirmControl.invalid || emailForm.hasError('emailsDontMatch')) &&
          confirmControl.touched
        "
        [errorMessage]="confirmValidationMessage"
      />

      <button
        type="submit"
        class="petszel-primary-button email-modal__submit"
        [disabled]="emailForm.invalid || isSaving()"
      >
        @if (isSaving()) {
          {{ mode() === "edit" ? "Updating…" : "Adding…" }}
        } @else {
          {{ mode() === "edit" ? "Update email" : "Add email" }}
        }
      </button>
    </form>
  </div>
</section>
